import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const navLinks = [
  { path: '/', label: '首页' },
  { path: '/category/movie', label: '电影' },
  { path: '/category/tv', label: '电视剧' },
  { path: '/category/anime', label: '动漫' },
  { path: '/category/variety', label: '综艺' },
  { path: '/about', label: '关于我们' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [searchFocused, setSearchFocused] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-100/95 backdrop-blur-md'
          : 'bg-transparent'
      }`}
    >
      <div className="px-4 md:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 text-foreground-50 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
          >
            <div className="w-9 h-9 flex items-center justify-center">
              <i className="ri-movie-2-line text-2xl text-primary-500"></i>
            </div>
            <span className="text-xl font-heading font-bold tracking-wide">
              蘑菇影视
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-2 text-sm rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  location.pathname === link.path
                    ? 'bg-primary-500/20 text-primary-400'
                    : 'text-foreground-300 hover:text-foreground-50 hover:bg-background-200/50'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className={`relative transition-all duration-300 ${searchFocused ? 'w-64' : 'w-48'}`}>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <i className="ri-search-line text-foreground-400 text-sm"></i>
                </div>
                <input
                  type="text"
                  placeholder="搜索影片..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  onFocus={() => setSearchFocused(true)}
                  onBlur={() => setSearchFocused(false)}
                  className="w-full pl-9 pr-4 py-2 text-sm bg-background-200/50 border border-background-300/50 rounded-full text-foreground-100 placeholder-foreground-500 focus:outline-none focus:border-primary-500/50 focus:bg-background-200 transition-all duration-200"
                />
              </div>
            </div>
            <button className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-500 hover:bg-primary-600 transition-colors duration-200 cursor-pointer">
              <i className="ri-user-line text-foreground-50 text-sm"></i>
            </button>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-9 h-9 flex items-center justify-center cursor-pointer"
          >
            <i className={`text-foreground-200 text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-100/98 backdrop-blur-md border-t border-background-200/50">
          <div className="px-4 py-4 space-y-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`block px-4 py-3 text-sm rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  location.pathname === link.path
                    ? 'bg-primary-500/20 text-primary-400'
                    : 'text-foreground-300 hover:text-foreground-50 hover:bg-background-200/50'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="pt-2">
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <i className="ri-search-line text-foreground-400 text-sm"></i>
                </div>
                <input
                  type="text"
                  placeholder="搜索影片..."
                  className="w-full pl-9 pr-4 py-2.5 text-sm bg-background-200/50 border border-background-300/50 rounded-lg text-foreground-100 placeholder-foreground-500 focus:outline-none focus:border-primary-500/50"
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}